<template>
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-12 col-lg-8">
        <CustomAlert v-if="$c('activityInstructions')" class="mb-4">
          {{ $c("activityInstructions") }}
        </CustomAlert>

        <div class="d-flex justify-content-between mb-4">
          <OffcanvasWrapper :title="'Table of Contents'" id="tableOfContents">
            <TableOfContents />
          </OffcanvasWrapper>

          <div v-if="useReport">
            <RouterLink
              :to="{ name: 'Report', params: { onid: 'bnob' } }"
              class="btn btn-light border border-dark d-flex align-items-center gap-2 fw-bold shadow-sm py-1"
            >
              <i class="bi bi-list-task fs-5"></i>
              <div>Report</div>
            </RouterLink>
          </div>
        </div>

        <div class="mb-4">
          <PromptContainer />
        </div>

        <StepController />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OffcanvasWrapper from "@/components/activity/OffcanvasWrapper.vue";
import TableOfContents from "@/components/activity/TableOfContents.vue";
import PromptContainer from "@/components/activity/PromptContainer.vue";
import StepController from "@/components/activity/StepController.vue";
export default {
  name: "ActivityView",
  components: {
    OffcanvasWrapper,
    TableOfContents,
    PromptContainer,
    StepController
  },
  computed: {
    ...mapGetters(["useReport"])
  }
};
</script>
